import base64 from './base64'
let util = {}
util.title = function (title) {
  title = title ? title + '' : 'iView project'
  window.document.title = title
}
util.base64 = import('./base64.js')
util.loadJS = function (url) {
  return new Promise(function (resolve, reject) {
    var s = document.createElement('script')
    s.setAttribute('src', url)
    document.head.appendChild(s)
    s.onload = resolve
    s.onerror = reject
  })
}
export default util



// WEBPACK FOOTER //
// ./src/utils/index.js